import AppRecord from './AppRecord.js'
import LossWarningNotification from './LossWarningNotification.js'
import APP from '../../../main.js'

class LossWarningLoss extends AppRecord {
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)||{}
  }
  // set notifications(array){
  //   this._notifications = array.map(item => new LossWarningNotification(item))
  // }
  get show_notifications(){
    if (this.notifications){
      return this.notifications.map((item => new LossWarningNotification(item)))
    }
    return []
  }

  get controller(){
    return this.constructor.employeeStore.controllers.LossWarningLossesController
  }
}

export default LossWarningLoss